"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERENCE_PRICE_SOURCE_LABELS = exports.LME_SETTLEMENT_REFERENCE_SOURCE = exports.REFERENCE_PRICE_SOURCES = void 0;
// Reference price source codes for Formula/Index-priced tickets. Matching,
// hedging, and template engines key off these values — renaming a code is a
// breaking change. Labels are display-only.
// REFERENCE_PRICE_SOURCES is the trader-selectable list the ticket form
// offers; LME_SETTLEMENT_REFERENCE_SOURCE is system-written provenance only
// (the match-time settlement fallback, Fizzy #1089) and must never appear in
// the form dropdown — it marks values a trader did NOT enter.
exports.REFERENCE_PRICE_SOURCES = ['LME', 'LME Ticker', 'LLME', 'Other'];
exports.LME_SETTLEMENT_REFERENCE_SOURCE = 'LME Settlement';
exports.REFERENCE_PRICE_SOURCE_LABELS = {
    LME: 'LME (manual)',
    'LME Ticker': 'LME Ticker (auto-fill)',
    LLME: 'LLME',
    Other: 'Other',
    'LME Settlement': 'LME Settlement (auto at matching)',
};
//# sourceMappingURL=reference-price-source.js.map